// base
export const SUCCESS_INIT = 'success';
export const SUCCESS_STATUS = 'success';
export const FAILED_STATUS = 'failed';
export const AXIOSFAILED = 'axios_failed';

export const UNAUTHORIZED = 'unauth';
export const NOTCOMPLETED = 'not_completed';
export const ENTITYFAILED = 'entity-error';
export const SERVERERROR = 'server-error';
export const FAILED = 'failed';

// profile status
export const FIRSTLOGIN = 'firstLogin';

export const OFFLINE = 'offline';
export const WIATFORPROFILE = 'wait_profile';
export const PROFILECOMPLETED = 'profile-completed';

// user
export const SIGNIN = 'waiting';
export const VERIFIED = 'verified';
export const WAITOTP = 'wait-otp';
